'use client';

import { c as _c } from "react/compiler-runtime";
import { cn } from '@src/utils/tailwind';
interface PasswordRuleProps {
  isValid: boolean;
  content: string;
  hasErrors: boolean;
  isDarkMode?: boolean;
}
export const PasswordRule = props => {
  const $ = _c(14);
  const {
    content,
    hasErrors,
    isValid,
    isDarkMode
  } = props;
  const t0 = hasErrors && !isValid;
  let t1;
  if ($[0] !== isValid || $[1] !== t0) {
    t1 = cn("size-2 rounded-full bg-bodi-gray-light", {
      "bg-bodi-accent-deep-500": isValid,
      "bg-bodi-red-deep-500": t0
    });
    $[0] = isValid;
    $[1] = t0;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  let t2;
  if ($[3] !== t1) {
    t2 = <div className={t1} />;
    $[3] = t1;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  const t3 = hasErrors && !isValid;
  let t4;
  if ($[5] !== isDarkMode || $[6] !== t3) {
    t4 = cn("text-body-xs", {
      "text-bodi-red-deep-500": t3,
      "text-bodi-gray-disabled": isDarkMode
    });
    $[5] = isDarkMode;
    $[6] = t3;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  let t5;
  if ($[8] !== content || $[9] !== t4) {
    t5 = <p className={t4}>{content}</p>;
    $[8] = content;
    $[9] = t4;
    $[10] = t5;
  } else {
    t5 = $[10];
  }
  let t6;
  if ($[11] !== t2 || $[12] !== t5) {
    t6 = <div className="flex items-center gap-3">{t2}{t5}</div>;
    $[11] = t2;
    $[12] = t5;
    $[13] = t6;
  } else {
    t6 = $[13];
  }
  return t6;
};